<template>
  <p
    v-html="description"
    class="product-description-container"
    :class="large ? 'large' : ''"
  ></p>
</template>

<script>
  export default {
    name: 'ProductDescription',
    components: {},
    props: {
      description: {
        required: true,
        default: '',
        type: String,
      },
      large: {
        required: false,
        default: false,
        type: Boolean,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .product-description-container {
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #000000;
  }

  .product-description-container.large {
    font-size: 16px;
    line-height: 22px;
  }
</style>
